import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { ToastProps } from 'react-toastify/dist/types';

const toastProps: Partial<ToastProps> = {
    bodyClassName: 'font-inter font-medium text-sm text-black',
    closeButton: ({ closeToast }) => (
        <IconButton disableRipple onClick={closeToast}>
            <CloseIcon className="self-center !w-[14px] mx-3" />
        </IconButton>
    ),
};

export { toastProps };
